import { action } from '@ember/object';
import type Owner from '@ember/owner';
import { next } from '@ember/runloop';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';

import $ from 'jquery';

import type { Service } from 'webapp-types';
import { uniq } from 'webapp/utils/common';

import type StoryElementBase from 'webapp/models-custom/story-element/base';

import StoryElement from 'webapp/custom-elements/story-element';

export default abstract class DataStoryBase<T> extends Component<T> {
	@service('data-story') declare dataStoryService: Service.DataStory;

	@tracked storyElements: StoryElement[] = [];

	abstract createStoryElementFor(_order: number, type: string): StoryElementBase | null;

	constructor(owner: Owner, args: T) {
		super(owner, args);

		// Define the new html element
		if (!customElements.get('story-element')) {
			customElements.define('story-element', StoryElement);
		}
	}

	_dataHashes: number[] = [];

	get dataHashes() {
		const currentHashes = this._dataHashes;
		const hashes = this.storyElements.map((node) => {
			const hash = node.model?.dataHash || 0;
			if (!hash || !currentHashes.includes(hash)) {
				node.updateAttributes();
			}
			return hash;
		});
		const uniqueHashes = uniq(hashes);
		// eslint-disable-next-line ember/no-side-effects
		this._dataHashes = uniqueHashes;
		return uniqueHashes;
	}

	get dataHashesString() {
		return this.dataHashes.join('-');
	}

	@action
	setupView(node: HTMLElement): void {
		$(node).data('getComponent', () => this);
	}

	onElementAdd(model: StoryElement) {
		this.storyElements = [...this.storyElements, model];
	}

	onElementRemove(model: StoryElement) {
		// next, bcos mass removals (e.g. on page exit) trigger rerender changes
		next(() => {
			this.storyElements = this.storyElements.filter((e) => e !== model);
		});
	}
}
